// This file should be an helper to use API platform response structure

export function getData(response) {
    if (!response['hydra:member']) {
        return null;
    }

    return response['hydra:member'];
}
